"use client";
import { createContext } from "react";
export const LazyContext = createContext({ strict: false });
//# sourceMappingURL=LazyContext.js.map